/**
 * @prop --padding-top: Padding top of sticky element
 * @prop --padding-bottom: Padding bottom of sticky element
 * @prop --padding-left: Padding left of sticky element
 * @prop --padding-right: Padding right of sticky element
 * @prop --background-color: Background color of sticky element
 * @prop --stuck-padding-top: Padding top of stuck sticky element
 * @prop --stuck-padding-bottom: Padding bottom of stuck sticky element
 * @prop --stuck-padding-left: Padding left of stuck sticky element
 * @prop --stuck-padding-right: Padding right of stuck sticky element
 * @prop --stuck-background-color: Background color of stuck sticky element
 *
 * @prop --stzh-sticky-{NAME}-is-stuck: **Global**: Whether sticky is currently stuck (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-is-not-stuck: **Global**: Whether sticky is currently not stuck (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-is-stuck-top: **Global**: Whether sticky is currently stuck on top (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-is-not-stuck-top: **Global**: Whether sticky is currently not stuck on top (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-is-stuck-bottom: **Global**: Whether sticky is currently stuck on bottom (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-is-not-stuck-bottom: **Global**: Whether sticky is currently not stuck on bottom (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-stuck-top-height: **Global**: Stuck top sticky element height (readonly variable on `<html>`)
 * @prop --stzh-sticky-{NAME}-stuck-bottom-height: **Global**: Stuck bottom sticky element height (readonly variable on `<html>`)
 */

:host {
  --padding-top: #{space('large')};
  --padding-bottom: #{space('large')};
  --padding-left: 0;
  --padding-right: 0;
  --background-color: transparent;

  --stuck-padding-top: var(--padding-top);
  --stuck-padding-bottom: var(--padding-bottom);
  --stuck-padding-left: var(--padding-left);
  --stuck-padding-right: var(--padding-right);
  --stuck-background-color: #{$colorGrey10};

  display: contents;

  @media print {
    display: none;
  }
}

:host([variant="transparent"]) {
  --background-color: transparent;
  --stuck-background-color: transparent;

  pointer-events: none;
}

:host([position="fixed"]) {
  display: block;
}

.stzh-sticky {
  display: contents;

  &__sticky {
    position: sticky;
    top: -1px;
    bottom: -1px;
    z-index: $zIndexSticky;
    width: var(--stzh-sticky-unstuck-width, auto);
    transition-property: width, transform, opacity;
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__content,
  &__content::before {
    background-color: var(--background-color);
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__content {
    --stzh-button-pointer-events: all;
    --stzh-link-pointer-events: all;

    position: relative;
    transition-property: background-color, transform;

    // &::before,
    // &::after {
    //   content: '';
    //   pointer-events: none;
    //   display: block;
    //   position: absolute;
    //   left: 0;
    //   width: 100%;
    //   height: space('xxlarge');
    //   opacity: 0;
    //   transition: opacity $baseTransitionAnimationSpeed;
    // }

    // &::before {
    //   background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    //   top: 0;
    //   transform: translateY(-100%);
    // }

    // &::after {
    //   background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    //   bottom: 0;
    //   transform: translateY(100%);
    // }
  }

  &__content-inner {
    padding-top: var(--padding-top);
    padding-bottom: var(--padding-bottom);
    padding-left: var(--padding-left);
    padding-right: var(--padding-right);
    transition-property: padding;
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__spacer {
    display: none;
  }

  /* Disabled variants */

  &--is-disabled-sticky-top &__sticky {
    top: auto;
  }

  &--is-disabled-sticky-bottom &__sticky {
    bottom: auto;
  }

  /* Bleeding variant */

  &--is-bleeding &__content {
    &::before {
      z-index: -1;
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      transform: translateY(0);
      transition-property: width, background-color, transform;
    }
  }

  /* Is stuck variant */

  &--is-stuck &__content,
  &--is-stuck &__content::before {
    background-color: var(--stuck-background-color);
  }

  &--is-stuck &__content::before {
    width: calc(100vw - var(--stzh-scrollbar-width));
    transform: translateX(calc(var(--stzh-sticky-offset-left) / -1));
  }

  &--is-stuck &__content-inner {
    padding-top: var(--stuck-padding-top);
    padding-bottom: var(--stuck-padding-bottom);
    padding-left: var(--stuck-padding-left);
    padding-right: var(--stuck-padding-right);
  }

  // &--is-stuck-bottom &__content {
  //   &::before {
  //     opacity: 1;
  //   }
  // }

  // &--is-stuck-top &__content {
  //   &::after {
  //     opacity: 1;
  //   }
  // }

  /* Transparent variant */

  // &--transparent &__content {
  //   &::after,
  //   &::before {
  //     display: none;
  //   }
  // }

  // /* Position sticky variant */

  // &--is-breakout &__content {
    // position: relative;
    // left: 50%;
    // right: 50%;
    // margin-left: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    // margin-right: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    // width: calc(100vw - var(--stzh-scrollbar-width));
    // max-width: calc(100vw - var(--stzh-scrollbar-width));
  // }

  &--is-not-loaded {
    visibility: hidden;
  }

  &--is-not-loaded#{&}--is-stuck &__sticky {
    transform: translateY(100%);
    opacity: 0;
  }

  &--is-not-loaded &__sticky,
  &--is-not-loaded &__content,
  &--is-not-loaded &__content::before,
  &--is-not-loaded &__content-inner {
    transition-duration: 0ms;
  }
}
